import { ToastViewport as ToastViewportOg } from "@decidr/primitives";

export const ToastViewport = () => {
  return <ToastViewportOg right={20} bottom={20} />;
};
